import Link from "next/link";
import { useTranslation } from "next-i18next";

import { Text } from "@/components/elements";
import { LINKS } from "@/constants/links";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { isWebshopClosed } from "@/utils/helpers";

import footer from "../footer.module.css";

const ShopLinks = [
  {
    href: LINKS.SHOP_SOAP,
    key: "navigation.category.soap",
  },
  {
    href: LINKS.SHOP_CLEANING,
    key: "navigation.category.cleaning",
  },
  {
    href: LINKS.SHOP_LAUNDRY,
    key: "navigation.category.laundry",
  },
  {
    href: LINKS.SHOP,
    key: "navigation.products",
  },
];

let InfoLinks = [
  {
    href: LINKS.WHAT_IS_PAFYLL,
    key: "navigation.what",
  },
  {
    href: LINKS.INSPIRATION,
    key: "navigation.articles",
  },
  {
    href: LINKS.FAQ,
    key: "navigation.faq",
  },
  {
    href: LINKS.CONTACT_US,
    key: "navigation.contact",
  },
];

const TermsLinks = [
  {
    href: LINKS.PRIVACY,
    key: "navigation.privacy",
  },
  {
    href: LINKS.TERMS,
    key: "navigation.service",
  },
];

const filterList = (list) => {
  if (isWebshopClosed) {
    return list.filter(({ key }) => key !== "navigation.articles");
  }

  return list;
};

const List = ({ title, list, t }) => {
  const modifiedList = filterList(list);

  return (
    <>
      <li>
        <Text as="h4">{t(`navigation.${title}`)}</Text>
        <ul className={footer.child_list}>
          {modifiedList.map(({ href, key }) => (
            <li key={key}>
              <Link href={href}>{t(key)}</Link>
            </li>
          ))}
        </ul>
      </li>
    </>
  );
};

export const Navigation = () => {
  const { t } = useTranslation("footer");
  const { faq_page_visible } = useSiteSettings();

  InfoLinks = faq_page_visible
    ? InfoLinks
    : InfoLinks.filter(({ key }) => key !== "navigation.faq");

  return (
    <nav className={footer.nav}>
      <ul className={footer.parent_list}>
        <List title="shop" list={ShopLinks} t={t} />
        <List title="about" list={InfoLinks} t={t} />
        <List title="terms" list={TermsLinks} t={t} />
      </ul>
    </nav>
  );
};
